import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';

const AttributeBadge = ({
  positive,
  children,
}: {
  positive: boolean;
  children: ReactNode;
}) => <BadgeRoot $positive={positive}>{children}</BadgeRoot>;

const BadgeRoot = styled('div')<{ $positive: boolean }>(
  ({ theme, $positive }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 75,
    height: 20,
    padding: '0 10px',
    borderRadius: theme.radii.md,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    ...($positive
      ? {
          backgroundColor: theme.palette.green50,
          border: `1px solid ${theme.palette.green400}`,
          color: theme.palette.green700,
        }
      : {
          backgroundColor: theme.palette.grey50,
          border: `1px solid ${theme.palette.grey400}`,
          color: theme.palette.grey500,
        }),
  }),
);

export default AttributeBadge;
